<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="indigo darken-4">
      <v-toolbar-title>{{
        $vuetify.t('$vuetify.app.forgotPassword')
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-avatar :tile="tile" size="32" color="grey lighten-4">
        <img src="/img/mobile-info-192.png" alt="avatar" />
      </v-avatar>
    </v-toolbar>
    <v-card-text>
      <v-alert :value="invalidCredentials" color="error">
        {{ $vuetify.t('$vuetify.app.invalidCredentials') }}
      </v-alert>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-text-field
          name="username"
          v-model="auth.username"
          :rules="[rules.required]"
          :label="$vuetify.t('$vuetify.app.username')"
        ></v-text-field>
        <v-card-actions>
          <v-btn @click="goLogin" flat left>Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="submit" :loading="loading" large dark>Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'reset',
  $validates: true,
  data() {
    return {
      loading: false,
      auth: {
        username: ''
      },
      valid: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      errors: [],
      tile: null,
      invalidCredentials: false
    }
  },
  computed: {
    layout() {
      return 'login-layout'
    },
    isFormValid() {
      return (
        this.valid &&
        !Object.keys(this.fields).some(key => this.fields[key].invalid)
      )
    }
  },
  methods: {
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    ...mapActions({
      forgotPassword: 'root/forgotPassword',
      setLayout: 'root/setLayout',
      attachAuthHeader: 'root/attachAuthHeader'
    }),
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.invalidCredentials = false

        this.forgotPassword({ data: this.auth })
          .then(response => {
            this.loading = false
            this.setNotification(response.message)
            this.$router.push({ name: 'login' })
          })
          .catch(error => {
            this.loading = false
            this.setNotification(error.response.data.message)
            this.$refs.form.reset()
            this.$refs.form.validate()
          })
      }
    },
    goLogin() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
